import { Box } from "@mui/material";
import { Outlet } from "react-router";
import Header from "./Header";
import Footer from "./Footer";

export default function SiteLayout() {
  return (
    <Box>
      <Header />
      <Outlet />
      <Footer />
    </Box>
  );
}